import { createSelector } from 'reselect';
import memoize from 'lodash.memoize';

const selectCustomer = (state) => state.customer;

export const selectCustomerData = createSelector(
  [selectCustomer],
  (customer) => customer.customerData
);
export const selectCustomerByName = memoize((customerName) =>
  createSelector([selectCustomerData], (customerData) => {
    customerData.forEach((customer) => {
      if (customer.name === customerName) {
        return customer;
      }
    });
  })
);
